export default __webpack_public_path__ + "3da713418d8405010a96cb36985d4456.svg";